import Carousel from './modules/carousel.js';
Carousel();

// import ScrollIndicator from './modules/scroll-indicator.js';
// ScrollIndicator();

import Video from './modules/video.js';
Video();